<template>
  <div class="row f-row">
    <div class="col col-cx">
      <div class="row f-row" style="position: relative">
        <!-- Select company portfolio product/currency-->
        <div
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;
            padding:  0 5px 0 5px !important;"
        >
          <button
            style="width: 22px; margin: 0!important; "
            class="btn btn-strat-blue"
            v-on:click="onUserFetchExpand"
          >
            <i
              v-if="toBeFetchedHidden"
              class="fa fa-angle-double-right"
              style="font-size: 1.2rem"
            ></i>
            <i
              v-else
              class="fa fa-angle-double-left"
              style="font-size: 1.2rem"
            ></i>
          </button>
        </div>
        <div
          v-if="toBeFetchedHidden"
          class="col col-auto txt-label-primary-2"
          style="padding-right: 8px !important;"
        >
          <button
            style="width: 22px; margin: 0!important;"
            class="btn btn-strat-blue"
            v-on:click="onUserFetchData"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div>
        <template v-if="!toBeFetchedHidden">
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span style="padding-right: 8px!important;">Companies:</span>
          </div>
          <div class="col col-2 no-dropdown" v-if="companies.length === 0">
            N.A.
          </div>
          <div class="col col-2 no-dropdown" v-else-if="companies.length === 1">
            {{ newSelectedCompanies[0].company_name }}
          </div>
          <div class="col col-2 text-left" v-else>
            <MultiSelect
              v-model="newSelectedCompanies"
              :options="companies"
              :filter="true"
              placeholder="Select Companies"
              class="p-column-filter"
              optionLabel="company_name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">{{
                    slotProps.option.company_name
                  }}</span>
                </div>
              </template>
            </MultiSelect>
          </div>

          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >Portfolios:</span
            >
          </div>
          <div class="col col-2 no-dropdown" v-if="newPortfolios.length === 0">
            N.A.
          </div>
          <div
            class="col col-2 no-dropdown bdr-b-h"
            v-else-if="newPortfolios.length === 1"
          >
            {{ newSelectedPortfolios[0].name }}
          </div>
          <div class="col col-2 text-left" v-else>
            <MultiSelect
              v-model="newSelectedPortfolios"
              :options="newPortfolios"
              :filter="true"
              placeholder="Select Portfolios"
              class="p-column-filter"
              optionLabel="name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">
                    <template v-if="newSelectedCompanies.length > 1">
                      {{ slotProps.option.companyName }} -
                    </template>
                    {{ slotProps.option.name }}</span
                  >
                </div>
              </template>
            </MultiSelect>
          </div>

          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >{{ isCurrency ? "Currency" : "Product" }}:</span
            >
          </div>
          <div
            class="col col-2 no-dropdown bdr-b-h"
            v-if="newAssets.length === 0"
          >
            N.A.
          </div>
          <div class="col col-2 text-left" v-else>
            <MultiSelect
              v-model="newSelectedAsset"
              :options="newAssets"
              :filter="true"
              placeholder="Select Assets"
              class="p-column-filter"
              optionLabel="product_name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">{{
                    slotProps.option.product_name
                  }}</span>
                </div>
              </template>
            </MultiSelect>
          </div>
          <div
            class="col"
            :class="screenWidth < 1280 ? 'col-2' : 'col-1'"
            v-if="toBeFetched"
          >
            <button
              type="button"
              :disabled="showLoadingSpot"
              class="btn btn-strat-blue"
              style="margin: 0!important;"
              v-on:click="onUserFetchData"
            >
              <span v-if="showLoadingSpot" class="text-left mr-2">
                <QSLoading
                  :isLoading="showLoadingSpot"
                  :size="20"
                  :colorTheme="colorTheme"
              /></span>
              <span v-if="showLoadingSpot">Loading Data</span>
              <span v-else>Get Information</span>
            </button>
          </div>
          <div
            class="col col-auto"
            style="padding: 0 8px 0 5px !important;"
            v-else
          >
            <button
              style="width: 22px; margin: 0!important;"
              class="btn btn-strat-blue"
              v-on:click="onUserFetchData"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
        </template>

        <!-- VaR -->
        <template v-if="pickedAnalysis !== 1">
          <div
            class="col col-auto txt-label-primary-2 bdr-l"
            style="justify-content: flex-start!important;"
          >
            <label
              class="ml-2"
              v-bind:class="[
                showSimulations ? 'btn-checkbox-active' : 'btn-checkbox',
              ]"
            >
              <input type="checkbox" v-on:click="onClientShowSims" />
              <span>
                <span
                  class="inh"
                  style="width: 10px!important;"
                  v-if="showSimulations"
                >
                  &#x2714;
                </span>
                <span class="inh" style="width: 10px!important;" v-else
                  >&#x2022;</span
                >
                <span
                  style="padding-left: 5px;"
                  :style="{
                    color: showSimulations
                      ? 'var(--textative)'
                      : 'var(--textinactive)',
                  }"
                  >VaR</span
                >
              </span>
            </label>
          </div>
        </template>

        <!-- Risk -->
        <template v-else>
          <div
            class="col col-auto txt-label-primary-2 bdr-l"
            style="justify-content: flex-start!important;"
          >
            <label
              class="ml-2"
              v-bind:class="[
                showStats ? 'btn-checkbox-active' : 'btn-checkbox',
              ]"
            >
              <input type="checkbox" v-on:click="onClientShowStats" />
              <span>
                <span
                  class="inh"
                  style="width: 10px!important;"
                  v-if="showStats"
                >
                  &#x2714;
                </span>
                <span class="inh" style="width: 10px!important;" v-else
                  >&#x2022;</span
                >
                <span
                  style="padding-left: 5px;"
                  :style="{
                    color: showStats
                      ? 'var(--textative)'
                      : 'var(--textinactive)',
                  }"
                  >Stats</span
                >
              </span>
            </label>
          </div>
        </template>

        <!-- Bucket selectors -->
        <div
          class="col col-auto txt-label-primary-2 bdr-r"
          style="justify-content: flex-start!important; padding-right: 8px!important;"
        >
          <label
            class="ml-2"
            v-bind:class="[
              showBuckets ? 'btn-checkbox-active' : 'btn-checkbox',
            ]"
          >
            <input type="checkbox" v-on:click="onClientShowBuckets" />
            <span>
              <span
                class="inh"
                style="width: 10px!important;"
                v-if="showBuckets"
              >
                &#x2714;
              </span>
              <span class="inh" style="width: 10px!important;;" v-else
                >&#x2022;</span
              >
              <span
                style="padding-left: 5px;"
                :style="{
                  color: showBuckets
                    ? 'var(--textative)'
                    : 'var(--textinactive)',
                }"
                >View</span
              >
            </span>
          </label>
        </div>

        <template v-if="showSimulations && pickedAnalysis !== 1">
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              v-show="showLoadingSimulating"
              class="ml-1"
              style="padding-right: 2px!important; padding-left: 8px!important;"
              >Confidence:
              <QSLoading
                :isLoading="showLoadingSimulating"
                :size="20"
                :colorTheme="colorTheme"
              />
            </span>
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="width: 60px!important;"
          >
            <InputPercent
              v-model="confidenceAux"
              style="height: 25px!important;"
              @input="onUserConfidence"
            />
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 5px!important;"
              >(1 out of
              {{ (1 / (1 - confidenceAux / 100)) | numFormat }} times)</span
            >
          </div>
          <div class="col col-auto mr-1" v-if="showLoadingSimulating">
            <span class="text-right">
              <QSLoading
                :isLoading="showLoadingSimulating"
                :size="20"
                :colorTheme="colorTheme"
              />
            </span>
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span style="padding-right: 5px!important;"
              >{{
                simUpToDate ? "Simulations" : "Run 5.000 simulations"
              }}:</span
            >
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="padding-right: 8px!important;"
          >
            <button
              style="width: 22px; margin: 0!important;"
              class="btn btn-strat-blue"
              v-on:click="onUserSimulate"
            >
              <i
                class="fa fa-send-o"
                aria-hidden="true"
                v-if="!simUpToDate"
              ></i>
              <i class="fa fa-check" aria-hidden="true" v-else></i>
            </button>
          </div>
          <div class="col col-auto txt-label-primary-2" v-show="simsExist">
            <div
              class="btn-toolbar"
              role="toolbar"
              aria-label="Toolbar with button groups"
            >
              <div
                class="btn-group btn-group-toggle btn-block"
                role="group"
                style="width: 300px!important;"
              >
                <button
                  type="button"
                  class="btn btn-candle"
                  style="width: 33.334%!important;"
                  v-on:click="pickedScenario('none')"
                  v-bind:class="[pickedScenarioVal === 'none' ? 'active' : '']"
                >
                  Market
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  style="width: 33.334%!important;"
                  v-on:click="pickedScenario('up')"
                  v-bind:class="[pickedScenarioVal === 'up' ? 'active' : '']"
                >
                  <i class="fa fa-long-arrow-up mr-auto"></i>
                  VaR ({{
                    (1 - (1 - confidenceAux / 100) / 2) | percentageFormat
                  }})
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  style="width: 33.334%!important;"
                  v-on:click="pickedScenario('down')"
                  v-bind:class="[pickedScenarioVal === 'down' ? 'active' : '']"
                >
                  <i class="fa fa-long-arrow-down mr-auto"></i>
                  VaR ({{
                    (1 - (1 - confidenceAux / 100) / 2) | percentageFormat
                  }})
                </button>
              </div>
            </div>
          </div>
        </template>
        <template v-if="showBuckets">
          <div
            v-if="pickedAnalysis !== 1"
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span style="padding-left: 8px!important;">Historical:</span>
          </div>

          <div class="col col-auto ml-1" v-if="pickedAnalysis !== 1">
            <HoverMultiSelection
              :btnWidth="'2.5rem'"
              :options="[
                { label: '1M', value: '1M' },
                { label: '3M', value: '3M' },
                { label: '6M', value: '6M' },
                { label: '1Y', value: '1Y' },
                { label: '2Y', value: '2Y' },
                { label: '5Y', value: '5Y' },
              ]"
              :selected="newPickedIntervalHistory"
              @eventOnChangeOption="
                (opt) => onHistoricalIntervalChange(opt.value)
              "
            />
          </div>
          <div
            v-if="pickedAnalysis !== 1"
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span style="padding-left: 16px!important;">Buckets:</span>
          </div>
          <div class="col col-auto ml-1" v-if="pickedAnalysis !== 1">
            <HoverMultiSelection
              :btnWidth="'2.5rem'"
              :options="[
                { label: '1W', value: '1W' },
                { label: '2W', value: '2W' },
                { label: '1M', value: '1M' },
                { label: '1Q', value: '1Q' },
                { label: '1Y', value: '1Y' },
              ]"
              :selected="pickedBucket"
              @eventOnChangeOption="(opt) => onBucketChange(opt.value)"
            />
          </div>

          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 5px!important; padding-left: 8px!important;"
              >Exposure:</span
            >
          </div>
          <div class="col col-auto txt-label-primary-2">
            <label
              :for="'dateExpo'"
              class="toggle__button_rt"
              style="height: 20px"
              :class="{ actives: newSelectedExpoDate }"
            >
              <input
                type="checkbox"
                @click="onUserSelectExpoDate"
                :id="'dateExpo'"
                v-model="newSelectedExpoDate"
              />
              <span
                class="toggle__switch_rt"
                style="min-width: 10rem!important;"
              >
                <div class="row f-row justify-content-center">
                  <div
                    class="col col-6 txt-label-primary-2 text-center"
                    style="font-size: 0.8rem!important;"
                  >
                    Expiration
                  </div>
                  <div
                    class="col col-6 txt-label-primary-2 text-center"
                    style="font-size: 0.8rem!important;"
                  >
                    Assigned
                  </div>
                </div>
              </span>
            </label>
          </div>

          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 5px!important; padding-left: 8px!important;"
              >Hedges:</span
            >
          </div>
          <div class="col col-auto text-left">
            <label
              :for="'dateHedge'"
              class="toggle__button_rt"
              style="height: 20px"
              :class="{ actives: newSelectedHedgeDate }"
            >
              <input
                type="checkbox"
                @click="onUserSelectHedgeDate"
                :id="'dateHedge'"
                v-model="newSelectedHedgeDate"
              />
              <span
                class="toggle__switch_rt"
                style="min-width: 10rem!important;"
              >
                <div class="row f-row justify-content-center">
                  <div
                    class="col col-6 txt-label-primary-2 text-center"
                    style="font-size: 0.8rem!important;"
                  >
                    Expiration
                  </div>
                  <div
                    class="col col-6 txt-label-primary-2 text-center"
                    style="font-size: 0.8rem!important;"
                  >
                    Assigned
                  </div>
                </div>
              </span>
            </label>
          </div>

          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 5px!important; padding-left: 8px!important;"
              >Derivatives detail:</span
            >
          </div>
          <div class="col col-auto text-left">
            <label
              :for="'dateDeriv'"
              class="toggle__button_rt"
              style="height: 20px"
              :class="{ actives: newSelectedDerivativeDate }"
            >
              <input
                type="checkbox"
                @click="onUserSelectedDerivativeDate"
                :id="'dateDeriv'"
                v-model="newSelectedDerivativeDate"
              />
              <span
                class="toggle__switch_rt"
                style="min-width: 10rem!important;"
              >
                <div class="row f-row justify-content-center">
                  <div
                    class="col col-6 txt-label-primary-2 text-center"
                    style="font-size: 0.8rem!important;"
                  >
                    Expiration
                  </div>
                  <div
                    class="col col-6 txt-label-primary-2 text-center"
                    style="font-size: 0.8rem!important;"
                  >
                    Assigned
                  </div>
                </div>
              </span>
            </label>
          </div>
        </template>

        <!-- Volatility -->
        <template v-if="pickedAnalysis === 1 && showStats">
          <div class="col col-auto">&nbsp;</div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding-left: 5px!important;"
          >
            Volatility (% annualized):
          </div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding: 0 9px 0 5px!important;"
          >
            <span style="padding-left: 5px; padding-right: 3px!important;"
              >Market</span
            >
            <div
              class="col col-auto txt-label-primary-2"
              v-if="showLoadingVolatility"
            >
              <QSLoading
                :isLoading="showLoadingVolatility"
                :size="20"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              v-else
              class="inh"
              style="font-size: 1.3rem; color: var(--textactive);"
            >
              {{ pastVolatility.unhedged | percentageFormat }}
            </div>
          </div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding-right: 9px!important;"
          >
            <span style="padding-left: 5px; padding-right: 3px!important;"
              >Hedges</span
            >
            <div
              class="col col-auto txt-label-primary-2"
              v-if="showLoadingVolatility"
            >
              <QSLoading
                :isLoading="showLoadingVolatility"
                :size="20"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              v-else
              class="inh"
              style="font-size: 1.3rem; color: var(--fwd);"
            >
              {{ pastVolatility.hedged | percentageFormat }}
            </div>
          </div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding-right: 9px!important;"
          >
            <span style="padding-left: 5px; padding-right: 3px!important;"
              >Net</span
            >
            <div
              class="col col-auto txt-label-primary-2"
              v-if="showLoadingVolatility"
            >
              <QSLoading
                :isLoading="showLoadingVolatility"
                :size="20"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              v-else
              class="inh"
              style="font-size: 1.3rem; color: var(--net);"
            >
              {{ pastVolatility.net | percentageFormat }}
            </div>
          </div>
        </template>

        <!-- Stats -->
        <template v-if="pickedAnalysis === 1 && showStats">
          <div class="col col-auto">&nbsp;</div>
          <div class="col col-auto bdr-l">&nbsp;</div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding-left: 5px!important;"
          >
            Monthly stats:
          </div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding: 0 9px 0 5px!important;"
          >
            <span style="padding-left: 5px; padding-right: 3px!important;"
              >Neutral</span
            >
            <div
              class="col col-auto txt-label-primary-2"
              v-if="showLoadingVolatility"
            >
              <QSLoading
                :isLoading="showLoadingVolatility"
                :size="20"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              v-else
              class="inh"
              style="font-size: 1.3rem; color: var(--textactive);"
            >
              {{ hedgingStats.neutral | percentageFormat }}
            </div>
          </div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding-right: 9px!important;"
          >
            <span style="padding-left: 5px; padding-right: 3px!important;"
              >Positive</span
            >
            <div
              class="col col-auto txt-label-primary-2"
              v-if="showLoadingVolatility"
            >
              <QSLoading
                :isLoading="showLoadingVolatility"
                :size="20"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              v-else
              class="inh"
              style="font-size: 1.3rem; color: var(--symmetry-h);"
            >
              {{ hedgingStats.positive | percentageFormat }}
              <sup style="color: var(--textactive);">
                Ave: {{ hedgingStats.posVal | numFormat }}
              </sup>
            </div>
          </div>
          <div
            class="col col-auto txt-label-primary-2 h_background"
            style="justify-content: flex-start!important; padding-right: 9px!important;"
          >
            <span style="padding-left: 5px; padding-right: 3px!important;"
              >Negative</span
            >
            <div
              class="col col-auto txt-label-primary-2"
              v-if="showLoadingVolatility"
            >
              <QSLoading
                :isLoading="showLoadingVolatility"
                :size="20"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              v-else
              class="inh"
              style="font-size: 1.3rem; color: var(--red);"
            >
              {{ hedgingStats.negative | percentageFormat }}
              <sup style="color: var(--textactive);">
                Ave: {{ hedgingStats.negVal | numFormat }}
              </sup>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- Spot -->
    <div class="col col-auto" v-if="toBeFetchedHidden">
      <div class="row f-row">
        <div
          class="col col-auto txt-label-primary-2 bdr-l"
          style="justify-content: flex-start!important;"
        >
          <span style="padding: 0 8px 0 8px!important;"
            >{{
              assetReference === "currency"
                ? "Spot"
                : "Spot (c" + contractCommodity + ")"
            }}:
            <i
              v-show="assetReference !== 'currency'"
              class="fa fa-question-circle txt-label-primary-2"
              style="display: inline; font-size: 1.3rem!important;"
              @mouseover="onHoverHelp(true)"
              @mouseleave="onHoverHelp(false)"
            ></i
          ></span>
        </div>
        <div class="col col-auto txt-label-primary-2" v-if="showLoadingSpot">
          <QSLoading
            :isLoading="showLoadingSpot"
            :size="20"
            :colorTheme="colorTheme"
          />
        </div>
        <div class="col col-auto">
          <InputNumber
            style="height: 28px!important; padding-right: 2px; width: 8rem!important;"
            :fontSize="'1.3rem'"
            :tableFormat="false"
            :deactivate="pickedAnalysis === 1"
            :value="+newSpot"
            @input="(val) => onUserSpotChange(val)"
          />
        </div>
        <div class="col col-auto txt-label-primary-2">
          <button
            style="width: 22px; margin: 0!important;"
            class="btn btn-strat-blue"
            v-on:click="onUserFetchData"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div>
        <div
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important; padding-right: 12px!important;"
        >
          <span style="padding-left: 5px; padding-right: 5px!important;"
            >Resize charts:</span
          >
          <div class="inh" style="font-size: 1.3rem">
            <button class="inh" @click="onUserRestoreSizes">
              <i class="fa fa-arrows-alt" title="Restore chart sizes"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPortfolios, getAssets } from "@/_core/data/Advanced";
import { format, select } from "d3";
import {
  darkBackground,
  grayLightBackground,
  textactive2,
} from "@/_core/_helpers/_parametric_tools";
import { getDefaultAnalyticsPreferences } from "@/_core/data/Advanced";
import HoverMultiSelection from "@/components/buttons/HoverMultiSelection.vue";
import InputPercent from "@/components/InputPercent.vue";
import InputNumber from "@/components/InputNumber.vue";
import MultiSelect from "primevue/multiselect";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "AdvancedSelectors",
  props: {
    analytics_preferences: { required: true },
    assetReference: { default: "currency" },
    assets: {
      required: true,
      default: [
        {
          product_name: "N.A.",
          fk_idcurrency: "N.A.",
          fk_idunit: "N.A.",
          currency_name: "N.A/N.A",
        },
      ],
    },
    colorTheme: { required: true, type: Boolean, default: true },
    commodityDetails: { required: false, default: "" },
    companies: { required: true, default: [{ id: 0, company_name: "N.A." }] },
    confidence: { required: true },
    contractCommodity: { required: false, default: 1 },
    currencySpecs: { required: false, default: () => [] },
    expandSelectors: { required: true, type: Boolean, default: false },
    expoDates: { required: false, default: () => [] },
    hedgeDates: { required: false, default: () => [] },
    hedgingStats: {
      required: false,
      default: {
        positive: 33.33,
        negative: 33.33,
        neutral: 33.34,
        posVal: 11,
        negVal: 11,
      },
    },
    isCurrency: { required: true },
    pastVolatility: {
      required: true,
      default: { unhedged: 0, hedged: 0, net: 0 },
    },
    pickedAnalysis: { required: true },
    pickedBucket: { required: true },
    pickedIntervalHistory: { required: true },
    pickedScenarioVal: { required: true },
    portfolios: { required: true, default: () => [] },
    processData: { required: true },
    selectedAsset: { required: true, default: 0 },
    selectedAssetStr: { required: true, default: "NA" },
    selectedCompanies: {
      required: true,
      default: [{ id: 0, company_name: "N.A." }],
    },
    selectedDerivativeDate: { required: false, default: 1 },
    selectedExpoDate: { required: false, default: 1 },
    selectedHedgeDate: { required: false, default: 1 },
    selectedPortfolios: { required: true, default: 0 },
    showAve: { required: true },
    showBudget: { required: true },
    showLoadingSimulating: { required: true },
    showLoadingSpot: { required: true, type: Boolean, default: true },
    showLoadingVolatility: { required: true, type: Boolean, default: true },
    showSimulations: { required: true, default: true, type: Boolean },
    showTooltip: { required: true },
    showTooltipDeriv: { required: true },
    simRate: { required: false, default: null },
    simsExist: { required: true },
    simUpToDate: { required: true },
    spot: { required: true },
    toBeFetched: { required: true, type: Boolean, default: true },
    toBeFetchedHidden: { required: true, type: Boolean, default: false },
  },
  components: {
    HoverMultiSelection,
    InputNumber,
    InputPercent,
    MultiSelect,
    QSLoading,
  },
  data() {
    return {
      confidenceAux: 67,
      currencyOrCommodity: "",
      currentCompany: [],
      currentPortfolio: [],
      isInitial: false,
      newAssets: [
        {
          product_name: "N.A.",
          fk_idcurrency: "N.A.",
          fk_idunit: "N.A.",
          currency_name: "EURUSD",
          pk_i_idcurrency: 3,
          fk_idcurrency_right: 0,
          fk_idcurrency_left: 0,
        },
      ],
      // newBudgetRate: 0,
      newPickedIntervalHistory: "1Y",
      newPortfolios: [],
      newSelectedAsset: [
        {
          product_name: "N.A.",
          fk_idcurrency: "N.A.",
          fk_idunit: "N.A.",
          currency_name: "EURUSD",
          pk_i_idcurrency: 3,
          fk_idcurrency_right: 0,
          fk_idcurrency_left: 0,
        },
      ],
      newSelectedCompanies: 0,
      newSelectedDerivativeDate: true,
      newSelectedExpoDate: true,
      newSelectedHedgeDate: true,
      newSelectedPortfolios: [],
      newSpot: 0,
      screenWidth: 0,
      showBuckets: false,
      showStats: false,
      simRateAux: 0,
      tooltip: null,
    };
  },
  mounted() {
    this.updateScreenWidth();
    this.analytics_preferences = getDefaultAnalyticsPreferences(this)[
      "choices"
    ];
    this.newSelectedCompanies = this.selectedCompanies;
    this.currentCompany = this.selectedCompanies;
    this.newPickedIntervalHistory = this.pickedIntervalHistory;
    this.currencyOrCommodity = this.isCurrency ? "Currency" : "Commodity";
    this.newPortfolios = this.portfolios;
    this.newSelectedPortfolios = this.selectedPortfolios;
    this.currentPortfolio = this.newSelectedPortfolios;
    this.newAssets = this.assets;
    this.newSelectedAsset = this.selectedAsset;
    this.newSpot = this.spot;
    this.newSelectedExpoDate = this.selectedExpoDate === 1;
    this.newSelectedDerivativeDate = this.selectedDerivativeDate === 1;
    this.newSelectedHedgeDate = this.selectedHedgeDate === 1;
    this.tooltip = select("#whole-page-div")
      .append("div")
      .style("opacity", 0)
      .style("margin", 0)
      .style("padding", "8px")
      .style("text-align", "center")
      .style("background", darkBackground(this.colorTheme))
      .style("border", grayLightBackground(this.colorTheme))
      .style("color", textactive2(this.colorTheme))
      .attr("class", "tooltip")
      .style("font-size", "0.8rem")
      .style("width", "350px")
      .html("");
    this.confidenceAux = this.confidence;
    this.simRateAux = this.simRate;
  },
  watch: {
    colorTheme() {
      this.tooltip
        .style("background", darkBackground(this.colorTheme))
        .style("border", grayLightBackground(this.colorTheme))
        .style("color", textactive2(this.colorTheme));
    },
    pickedAnalysis(val) {
      this.showStats = val === 1;
      this.showBuckets = this.showStats ? false : this.showBuckets;
    },
    confidence(val) {
      this.confidenceAux = val;
    },
    simRate(val) {
      this.simRateAux = val;
    },
    selectedDerivativeDate() {
      this.newSelectedDerivativeDate = this.selectedDerivativeDate === 1;
    },
    selectedExpoDate() {
      this.newSelectedExpoDate = this.selectedExpoDate === 1;
    },
    selectedHedgeDate() {
      this.newSelectedHedgeDate = this.selectedHedgeDate === 1;
    },
    spot() {
      this.newSpot = this.spot;
    },
    selectedCompanies(val) {
      this.newSelectedCompanies = val;
      this.currentCompany = val;
    },
    selectedPortfolios(val) {
      this.newSelectedPortfolios = val;
      this.currentPortfolio = val;
      this.analytics_preferences.selected_portfolio = this.newSelectedPortfolios;
      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        this.analytics_preferences,
      );
    },
    selectedAsset(val) {
      this.newSelectedAsset = val;
      this.analytics_preferences.selectedAsset = val;
      this.analytics_preferences.selected_commodities = val;
      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        this.analytics_preferences,
      );
    },
    newSelectedAsset() {
      this.changeUserSelection();
    },
    newSelectedPortfolios() {
      getAssets(
        this,
        "asset",
        "newSelectedPortfolios",
        false,
        "newPortfolios",
        "newAssets",
        "newSelectedAsset",
        "analytics_preferences",
      );
      this.currentPortfolio = this.newSelectedPortfolios;
      // Override with route query commodities if present
      const routeCommodities =
        this.$route && this.$route.query && this.$route.query.commodities;
      if (routeCommodities && this.newAssets && this.newAssets.length > 0) {
        const commNames = routeCommodities.split(",");
        const filtered = this.newAssets.filter(
          (a) => a && commNames.includes(a.product_name),
        );
        if (filtered.length > 0) {
          this.newSelectedAsset = filtered;
        }
      }
    },
    newSelectedCompanies(val) {
      if (val.length > 0) {
        this.currentCompany = val;
        this.analytics_preferences.selected_company = val;
        this.$store.dispatch(
          "user_preferences/updateAnalyticsChoices",
          this.analytics_preferences,
        );
        this.newPortfolios = getPortfolios(this, this.assetReference, val);
        // Restore portfolios from preferences
        this.newSelectedPortfolios = [];
        const selPort = this.analytics_preferences.selected_portfolio;
        if (selPort && selPort.length > 0) {
          for (let i = 0; i < selPort.length; i++) {
            const portName = selPort[i].portfolio_name || selPort[i].name;
            const idx = this.newPortfolios.findIndex(
              (d) => d.name === portName,
            );
            if (idx > -1) {
              this.newSelectedPortfolios.push(this.newPortfolios[idx]);
            }
          }
        }
        // Override with route query if present
        const routePortfolios =
          this.$route && this.$route.query && this.$route.query.portfolios;
        if (routePortfolios) {
          const portNames = routePortfolios.split(",");
          const filtered = this.newPortfolios.filter((p) =>
            portNames.includes(p.name),
          );
          if (filtered.length > 0) this.newSelectedPortfolios = filtered;
        }
        // Fallback to first portfolio
        if (
          this.newSelectedPortfolios.length === 0 &&
          this.newPortfolios.length > 0
        ) {
          this.newSelectedPortfolios.push(this.newPortfolios[0]);
        }
        this.currentPortfolio = this.newSelectedPortfolios;
        this.isInitial =
          this.newSelectedAsset.length > 0
            ? this.newSelectedAsset[0] === undefined
            : this.newSelectedAsset === undefined;
      } else {
        this.newPortfolios = [];
        this.newSelectedPortfolios = [];
        this.currentPortfolio = this.newSelectedPortfolios;
        this.newAssets = [];
      }
    },
    assets() {
      this.newAssets = this.assets;
    },
    portfolios(val) {
      this.newPortfolios = val;
    },
    pickedIntervalHistory() {
      this.newPickedIntervalHistory = this.pickedIntervalHistory;
    },
    selectedAssetStr() {},
  },
  methods: {
    onUserRestoreSizes() {
      this.$emit("eventOnUserRestoreSizes");
    },
    pickedScenario(val) {
      this.$emit("eventOnPickedScenario", val);
    },
    onUserSimRateChange(val) {
      this.$emit("eventOnUserSimRateChange", val);
    },
    onUserConfidence() {
      this.$emit("eventOnUserConfidence", this.confidenceAux);
    },
    onUserSimulate() {
      this.$emit("eventOnUserSimulate");
    },
    onClientShowStats() {
      this.showStats = !this.showStats;
      this.showBuckets = this.showStats ? false : this.showBuckets;
    },
    onClientShowSims() {
      this.showBuckets = false;
      this.$emit("eventOnUserFetchExpand", true);
      this.$emit("eventOnClientShowSims", !this.showSimulations);
    },
    onClientShowBuckets() {
      this.$emit("eventOnUserFetchExpand", true);
      this.$emit("eventOnClientShowSims", false);
      this.showBuckets = !this.showBuckets;
      this.showStats = this.showBuckets ? false : this.showStats;
    },
    onUserFetchExpand() {
      this.showBuckets = false;
      this.showStats = false;
      // this.$emit("eventOnClientShowSims", false);
      this.$emit("eventOnUserFetchExpand", !this.toBeFetchedHidden);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    // === user interactions ===
    onUserSelectedDerivativeDate() {
      this.$emit(
        "eventOnUserSelectedDerivativeDate",
        this.newSelectedDerivativeDate ? 0 : 1,
      );
    },
    onUserSelectExpoDate() {
      this.$emit("eventOnUserSelectExpoDate", this.newSelectedExpoDate ? 0 : 1);
    },
    onUserSelectHedgeDate() {
      this.$emit(
        "eventOnUserSelectHedgeDate",
        this.newSelectedHedgeDate ? 0 : 1,
      );
    },
    valuesSelection() {
      return {
        company: this.newSelectedCompanies,
        portfolios: this.newPortfolios,
        selectedPortfolios: this.newSelectedPortfolios,
        asset: this.newAssets,
        selectedAsset: this.newSelectedAsset,
      };
    },
    emitF() {
      let val = this.valuesSelection();
      this.$emit("eventOnUserSelection", val);
    },
    changeUserSelection() {
      let val = this.valuesSelection();
      this.$emit("eventOnChangeUserSelection", val);
    },
    onUserFetchData() {
      this.$emit("eventOnChangeToBeFetched", this.toBeFetched);
      this.emitF();
    },
    onUserSpotChange(val) {
      this.$emit("eventOnUserSpotChange", val);
    },
    onShow(val) {
      this.$emit("eventOnShow", val);
    },
    onHistoricalIntervalChange(val) {
      this.$emit("eventOnChangeInterval", val);
    },
    onBucketChange(val) {
      this.$emit("eventOnBucketChange", val);
    },
    onHoverHelp(val) {
      if (val) {
        this.tooltip
          .style("opacity", 1)
          .style("left", this.screenWidth / 2 - 175 + "px")
          .style("top", "120px")
          .html(this.commodityDetails);
      } else {
        this.tooltip
          .style("right", "-1000000px")
          .style("top", "0px")
          .style("opacity", 0)
          .html("");
      }
    },
  },
  filters: {
    numFormat: function(val) {
      return val === null || !isFinite(val) || val === 0
        ? "-"
        : format(",.2r")(val);
    },
    percentageFormat: function(val) {
      return format(",.1%")(val);
    },
  },
};
</script>

<style scoped>
.toggle__button {
  vertical-align: middle !important;
  user-select: none;
  cursor: pointer;
}
.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button .toggle__switch {
  display: inline-block;
  height: 12px;
  border-radius: 6px;
  width: 20px;
  background: var(--lightbackground);
  box-shadow: inset 0 0 1px var(--lightbackground);
  position: relative;
  margin: 0;
  top: 2px;
  transition: all 0.25s;
}
.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  left: 0;
  top: 0;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}
.toggle__button .toggle__switch::after {
  background: var(--darkbackground);
  border: 1px solid var(--lightbackground);
  box-shadow: 0 0 1px white;
}
.toggle__button .toggle__switch::before {
  background: var(--darkbackground);
  border: 1px solid var(--lightbackground);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.active .toggle__switch {
  background: var(--lightbackground);
  box-shadow: inset 0 0 1px var(--lightbackground);
}
.active .toggle__switch::after,
.active .toggle__switch::before {
  transform: translateX(20px - 12px);
}
.active .toggle__switch::after {
  left: 8px;
  background: var(--expo-alpha-4);
  border: 1px solid var(--symmetry);
  box-shadow: 0 0 1px var(--expo);
}

.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "Expiration";
  font-size: 0.8rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "Assigned";
}
</style>
